import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import Parser from "@helpers/parser";
import { IconFilterOff } from "@tabler/icons-react";

import { Button, ChipPicker, Text } from "@fragments";

import { getMemberRoles, getSubscriptionStatuses } from "../../../enums";

import "./styles.scss";

export default function FiltersBar({ filters, plans, plansLoading, onToggle, onClear }) {
  const { t } = useTranslation("memberModals");

  const memberRoles = useMemo(() => getMemberRoles(t), [t]);
  const subscriptionStatuses = useMemo(() => getSubscriptionStatuses(t), [t]);

  const hasFilters =
    filters.roles.length > 0 ||
    filters.plan_ids.length > 0 ||
    filters.subscription_statuses.length > 0;

  const planOptions = plansLoading
    ? []
    : plans.map((plan) => ({
        id: plan.id,
        label: plan.price
          ? `${plan.label} — R$ ${Parser.price.brl(plan.price)}`
          : plan.label,
      }));

  function handleToggle(filterKey) {
    return (_, option) => onToggle(filterKey, option.id);
  }

  return (
    <div className="members-list-filters">
      <Text.span contrast={5}>{t("membersList.filters.label")}</Text.span>

      <ChipPicker
        title={t("membersList.filters.role")}
        multiple
        value={filters.roles}
        options={memberRoles}
        onChange={handleToggle("roles")}
      />
      <ChipPicker
        title={t("membersList.filters.plan")}
        multiple
        searchable
        value={filters.plan_ids}
        options={planOptions}
        onChange={handleToggle("plan_ids")}
      />
      <ChipPicker
        title={t("membersList.filters.subscriptionStatus")}
        multiple
        value={filters.subscription_statuses}
        options={subscriptionStatuses}
        onChange={handleToggle("subscription_statuses")}
      />

      {hasFilters && (
        <Button
          color="overlay"
          size="small"
          startIcon={<IconFilterOff size={16} stroke={2} />}
          text={t("membersList.filters.clear")}
          onClick={onClear}
          preventLoading
        />
      )}
    </div>
  );
}
